<template>
  <div>
    <div class="page f-pr">
	  <!-- 签到成功背景图	 -->
	  <div v-show="signStadus">
		   <img src="../assets/bg-qdcg.jpg" alt="" class="bg-img"/>
		  
		  
		 
		  <img src="../assets/qdcg.png" alt="" class="sign-ok-img" />
		  
		  <img src="../assets/sahua.png" alt="" class="sahua-ani" />
		  
		  
<!--		  <video ref="videoBox" src="../assets/signok.mp4" autoplay loop playsinline  muted></video>-->
		  
		  
		  
		  
		  
	  </div>
		<div  v-if="signStadus"></div>
	  <div v-else  @touchstart="handleTouchStart">
		   
		  <img src="../assets/bg-gz.jpg" alt="" class="bg-img" />
			
		  <div class="code" >
		  		  <img src="../assets/code.png" alt="" />
		  </div>
		  
	  </div>
	  
	  
	  
     
    </div>

	
	<!-- 返回签到 -->
	<a href="#/index" class="btn-back" v-if="!signStadus" @click="">
		<img src="../assets/btn-return.png" alt="" />
	</a>
    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
      </div>
    </van-overlay>
	
	
	<van-overlay :show="showSignStadus">
		<div v-if="signStadus">
			
		</div>
		<div  v-else>
			<img src="../assets/sahua0.png" alt="" class="sahua"/>
			<img src="../assets/gx.png" alt="" class="sign-gx" />
			<div class="code">
				<img src="../assets/qdsb.png" alt="" />
			</div>
		</div>
		
	</van-overlay>
	
    
  </div>
</template>

<script>

import {getUserDkStatus,gaizhang} from "@/api/api";
import {check} from "@/utils/check";

export default {


  data() {
    return {
		showLoading:false,
		
		
		
		//签到失败的时候  showSignStadus:true,  signStadus:false
		//签到成功的时候  showSignStadus:false,  signStadus:true
		
		//是否显示签到状态
		showSignStadus:false,
		//签到成功true 失败false
		signStadus:false
    };
  },
 
   mounted() {
     var that = this
     that.showLoading=true
     let mobile = window.localStorage.getItem('mobile')
     if(!mobile){
       this.$router.push({path:'/index'})
       return
     }
     getUserDkStatus(mobile).then(res=>{
       that.showLoading=false
       console.log('getUserDkStatus',res)
       if(res.data.dkStatus==1){
         that.signOk()
       }
     })
     // that.signFail()
     // that.signOk()
	 
	 
	 
	 // var i = 0
	 // var that = this
   //   setInterval(()=>{
		//  i++
		//
		//  if( i % 2 ){
		// 	 that.signOk()
		//  }else{
		// 	 that.signFail()
		//  }
	 // },3000)
  },
  methods: {
    palyVideo(){
       var v = this.$refs.videoBox
       v.play()
    },
    init(){
      this.showSignStadus = false
      this.signStadus = false
    },
		signOk(){
      var that = this
			this.showSignStadus = false
			this.signStadus = true


      this.$nextTick(()=>{
        setTimeout(()=>{
          that.palyVideo()
        },20)


      })
		},
		signFail(){
			this.showSignStadus = true
			this.signStadus = false
		},
    async handleTouchStart(event) {

      let that = this;
      console.log("event.touches.length", event.touches.length)
      if (event.touches.length != 4) {
        // if (event.touches.length == 2) {
        //   that.signOk()
        // }else if (event.touches.length == 3) {
        //   that.signFail()
        // }
        return
      }

      let timestamp = new Date().getTime();
      console.log("-----------------------")
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)

      console.log("盖章：", scope)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      console.log("-----------------------")
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        let dataArr = JSON.stringify(touchArr)
        let mobile = window.localStorage.getItem('mobile')
        let res = await gaizhang({ bian: dataArr,phone: mobile })
        // let res = {"success": true}
        console.log("盖章请求接口", res)
        if (!res.success) {
        	that.$toast("打卡失败，请重试")
          that.signFail()
        	return
        }else{
          that.$toast("打卡成功")
          that.signOk()
        }
      }
    }

  },
};
</script>
<style scoped lang="less">
	
	.page{

		height: 100vh;
		background: url(../assets/bg-gz.jpg)  center bottom no-repeat;
    overflow: hidden;
    position: fixed;
    z-index: 2;
	right: 0;
	width: 100vw;
    left: 0;
    top: 0;
	}
	.code{
		position: absolute;
		width: 100%;
		left: 0;
		top: 629px;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 382px;
			height: 382px;
			object-fit: contain;
		}
	}
	.sign-gx{
		position: absolute;
		width: 598px;
		height: 598px;
		object-fit: contain;
		left: 50%;
		top: 499px;
		margin-left: -298px;
		
		animation:  c 3.6s infinite linear;
	}
	.sahua{
		width: 750px;
		position: absolute;
		left: 0;
		top: 629px;
		animation:  zoom-in 1s  linear;
		animation-fill-mode: forwards;
	}
	@keyframes c {
	  0% {
		transform: rotate(0) ;
	  }
	 
	  100% {
		 transform: rotate(360deg) ;
	  }
	}
	
	@keyframes zoom-in{
	  0% {
		transform: scale(0);
	  }
	 
	  100% {
		 transform: scale(1);
	  }
	}
	
	
	.sahua-ani{
		position: absolute;
		left: 2px;
		top: 524px;
		width: 732px;
		animation:  zoom-in 1s  linear;
		animation-fill-mode: forwards;
	}
	.btn-back{
		position: absolute;
		z-index: 123456789;
		left: 528px;
		top: 1139px;
		img{
			width: 177px;
			display: block;
		}
	}
	.sign-ok-gx{
		
	}
	.sign-ok-img{
		width: 691px;
		position: absolute;
		left: 29px;
		top: 520px;
	}
	video{
		position: fixed;
		width: 100%;
		left: 0;
		top: 0;
		z-index: 999;
	}
</style>
